import { calculatePlayerOvr } from "./calculatePlayerOvr";
import getPlayerLineup from "./getPlayerLineup";
import { batterKeys, stateKeys } from "./publicKeys";
import { setDeckEffects } from "./setDeckEffects";


export default function calculateSetDeckAdditionalStates(player, playerInfos, position) {

    let additionalSetDeckStates = {'s1':0, 's2':0, 's3':0, 's4':0, 's5':0, 's6':0};

    setDeckEffects.map((effect, index) => {

        const setDeckState = playerInfos.setDeckStates[index]

        if(setDeckState.selected && setDeckState.isAvailable) {
            if(isPlayerTarget(player, setDeckState, effect, position, getPlayerLineup(playerInfos, position))) {
                const effectState = calculateEffectState(position, effect, setDeckState);

                stateKeys.forEach(stateKey => {
                    additionalSetDeckStates[stateKey] += effectState[stateKey];
                });
            }
        } else {
            return
        }
    });

    return additionalSetDeckStates
}


// type = ["CardType", "Team", "Position", "YearPosition", "OvrPosition" "NumberOfStar", "AllStarTeam", "BatterLineup", "TeamCardType", "TeamPosition"]

function isPlayerTarget(player, setDeckState, setDeckEffect, position, lineup) {
    const target = setDeckEffect[setDeckState.selected].target.type
    const playerTeam = player.isFa ? player.isFa : player.team

    if(target === "CardType") {
        return setDeckEffect[setDeckState.selected].target.cardTypes.includes(player.type)
    } else if(target === "Team") {
        return playerTeam === setDeckState.selection || player.type === "골든글러브"
    } else if(target === "Position") {
        return setDeckEffect[setDeckState.selected].target.positions.includes(position)
    } else if(target === "YearPosition") {
        return setDeckEffect[setDeckState.selected].target.positions.includes(position) && (player.year === setDeckState.selection || player.type === "임팩트")
    } else if(target === "OvrPosition") {
        return setDeckEffect[setDeckState.selected].target.positions.includes(position) && calculatePlayerOvr(player) >= 65
    } else if(target === "NumberOfStar") {
        return player.stars === setDeckEffect[setDeckState.selected].target.numberOfStar
    } else if(target === "AllStarTeam") {
        return setDeckEffect[setDeckState.selected].target.teams.includes(playerTeam) || player.type === "골든글러브"
    } else if(target === "BatterLineup") {
        return setDeckEffect[setDeckState.selected].target.positions.includes(lineup)
    } else if(target === "TeamCardType") {
        return (playerTeam === setDeckState.selection || player.type === "골든글러브") && setDeckEffect[setDeckState.selected].target.cardTypes.includes(player.type)
    } else if(target === "TeamPosition") {
        return (playerTeam === setDeckState.selection || player.type === "골든글러브") && setDeckEffect[setDeckState.selected].target.positions.includes(position)
    } else {
        return false
    }
}

function calculateEffectState(position, setDeckEffect, setDeckState) {
    if (setDeckEffect[setDeckState.selected].effect.type === "States") {
        return setDeckEffect[setDeckState.selected].effect.states
    } else {
        if(batterKeys.includes(position)) {
            return setDeckEffect[setDeckState.selected].effect.statesForBatter
        } else {
            return setDeckEffect[setDeckState.selected].effect.statesForPitcher
        }
    }
}
